import type { TrackingEntry as GQLItem } from '../generated/checkout.graphql';
import { take } from '../util';

export type TrackingEntry = {
  id?: number;
  provider?: 'ga' | 'facebook' | 'tik_tok' | 'reddit';
  trackingId?: string;
};

export const fromGql = (tracking: GQLItem): TrackingEntry =>
  take(tracking, 'id', 'provider', 'trackingId') as TrackingEntry;

export const fromGqlCollection = (trackings?: GQLItem[] | null): TrackingEntry[] => trackings?.map(fromGql) || [];
